var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBanner
    ? _c(
        "fixed-banner",
        {
          attrs: {
            icon: false,
            type: _vm.usageRestricted ? "error" : "notice",
            "position-fixed": _vm.positionFixed,
            "side-right": _vm.sideRight,
          },
        },
        [
          _c("account-usage-message", {
            attrs: {
              page: _vm.currentPage,
              "usage-restricted": _vm.usageRestricted,
              "remaining-usages": _vm.remainingUsages,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }